import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inventoryLabResultCreate" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "inventoryLabResult", params: {} },
              },
            },
            [_vm._v(" Inventory Lab Result ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "inventoryLabResultUpload", params: {} } } },
            [_vm._v(" Upload ")]
          ),
        ],
        1
      ),
      _c(
        VCard,
        { staticClass: "py-10" },
        [
          _c(
            VCardTitle,
            [
              _vm._v(" Lab Result Upload "),
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = true
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-information-outline")])],
                1
              ),
            ],
            1
          ),
          _c(
            VCardText,
            [
              _c(VFileInput, {
                attrs: {
                  accept: "text/csv,application/pdf",
                  multiple: "",
                  "show-size": "",
                  counter: "",
                  rules: [
                    (value) =>
                      !value ||
                      value.every((f) =>
                        ["csv", "pdf"].includes(
                          (f.name || "").split(".").pop().toLowerCase()
                        )
                      ) ||
                      "Only CSV or PDF files allowed",
                  ],
                  label: "Choose lab result file(s) — CSV or PDF",
                  hint: "You can select several PDF reports at once.",
                  "persistent-hint": "",
                  disabled: _vm.parsing,
                },
                model: {
                  value: _vm.selectedFiles,
                  callback: function ($$v) {
                    _vm.selectedFiles = $$v
                  },
                  expression: "selectedFiles",
                },
              }),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v(" Back ")]),
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: {
                    color: "primary",
                    disabled:
                      _vm.parsing || _vm.loading || !_vm.selectedFiles.length,
                    loading: _vm.parsing,
                  },
                  on: { click: _vm.uploadLabResults },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.parsing ? "Parsing…" : "Upload") + " "
                  ),
                ]
              ),
              _c(VSpacer),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "560px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v("Supported File Formats")]),
              _c(VCardText, [
                _c("h4", [_vm._v("CSV (multiple results)")]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      ' Columns named either "Date" or "Analysis Date" for the date. '
                    ),
                  ]),
                  _c("li", [_vm._v('A column named "Time" for the time.')]),
                  _c("li", [
                    _vm._v(
                      ' A column named either "AverOutN" or "Charge" for the document number. '
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      ' Additional columns named "Pb", "Sn", "Sb", "Ca", "Al", "Bi", "Cu", "Ni", "As", "Ag", "Fe", "Zn", "Te", "Se", "S", and "Cd" for lab elements. '
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      ' Optionally: "SampleNo" or "Sample No.", "Quality", "Program", "QMDelete" or "Operator". '
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      ' Date format "DD/MM/YYYY", time format "HH:mm:ss". '
                    ),
                  ]),
                ]),
                _c("h4", { staticClass: "mt-4" }, [
                  _vm._v("PDF (one result per file — select several at once)"),
                ]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      " Direct export from the spectrometer — Spark Q4, Bruker Q8, or Thermo XL3 (XRF). "
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      " The PDF must have selectable text. Scanned / image-only PDFs are not supported; please re-export the report as a digital PDF. "
                    ),
                  ]),
                ]),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "900px" },
          model: {
            value: _vm.previewDialog,
            callback: function ($$v) {
              _vm.previewDialog = $$v
            },
            expression: "previewDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [
                _vm._v("Preview (" + _vm._s(_vm.previewData.length) + " rows)"),
              ]),
              _c(
                VCardText,
                [
                  _vm.futureDateFound
                    ? _c(VAlert, { attrs: { type: "warning", dense: "" } }, [
                        _vm._v(" " + _vm._s(_vm.warningMessage) + " "),
                      ])
                    : _vm._e(),
                  _vm.failedFiles.length
                    ? _c(VAlert, { attrs: { type: "warning", dense: "" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.failedFiles.length) +
                            " file(s) could not be parsed and were skipped: "
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.failedFiles, function (f) {
                            return _c("li", { key: f.name }, [
                              _vm._v(
                                " " +
                                  _vm._s(f.name) +
                                  " — " +
                                  _vm._s(f.reason) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "table-scroll" },
                    [
                      _c(
                        VSimpleTable,
                        [
                          [
                            _c("thead", [
                              _c(
                                "tr",
                                _vm._l(_vm.previewHeaders, function (header) {
                                  return _c("th", { key: header }, [
                                    _vm._v(" " + _vm._s(header) + " "),
                                  ])
                                }),
                                0
                              ),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.previewData, function (row, i) {
                                return _c(
                                  "tr",
                                  { key: i },
                                  _vm._l(_vm.previewHeaders, function (header) {
                                    return _c(
                                      "td",
                                      { key: header, staticClass: "nowrap" },
                                      [
                                        header == "testTime"
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "formatDateTimeYear"
                                                    )(row[header])
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                " " + _vm._s(row[header]) + " "
                                              ),
                                            ]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "justify-space-around" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: "primary",
                        disabled: _vm.futureDateFound,
                        loading: _vm.loading,
                      },
                      on: { click: _vm.confirmUpload },
                    },
                    [_vm._v(" Confirm and Upload ")]
                  ),
                  _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          _vm.previewDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }